/* PuffLive — plays an aura loop shot on black and keys it onto the page in WebGL.
   Glow is un-screened (alpha from brightness); the figure (anything enclosed by the glow) stays opaque. */
(function () {
  if (window.PuffLive) return;
  const VS = 'attribute vec2 p;varying vec2 u;void main(){u=vec2(p.x*.5+.5,.5-p.y*.5);gl_Position=vec4(p,0.,1.);}';
  const FS = 'precision mediump float;varying vec2 u;uniform sampler2D v;uniform sampler2D m;void main(){vec3 c=texture2D(v,u).rgb;float mx=max(c.r,max(c.g,c.b));float k=smoothstep(.15,.85,texture2D(m,u).r);float aU=clamp((mx-.035)/.965,0.,1.);vec3 cu=aU>0.?c/max(mx,.001):vec3(0.);float a=mix(aU,1.,k);vec3 col=mix(cu,c,k);gl_FragColor=vec4(col*a,a);}';
  const MW = 264, T = 90;
  window.PuffLive = function (src) {
    const cv = document.createElement('canvas');
    const gl = cv.getContext('webgl', { premultipliedAlpha: true, alpha: true, antialias: false });
    if (!gl) return null;
    const sh = (t, s) => { const o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); return o; };
    const pr = gl.createProgram(); gl.attachShader(pr, sh(gl.VERTEX_SHADER, VS)); gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, FS)); gl.linkProgram(pr); gl.useProgram(pr);
    gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer()); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    const loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    const tex = (unit) => { const t = gl.createTexture(); gl.activeTexture(gl.TEXTURE0 + unit); gl.bindTexture(gl.TEXTURE_2D, t); [gl.TEXTURE_WRAP_S, gl.TEXTURE_WRAP_T].forEach(k => gl.texParameteri(gl.TEXTURE_2D, k, gl.CLAMP_TO_EDGE)); [gl.TEXTURE_MIN_FILTER, gl.TEXTURE_MAG_FILTER].forEach(k => gl.texParameteri(gl.TEXTURE_2D, k, gl.LINEAR)); return t; };
    const tv = tex(0), tm = tex(1);
    gl.uniform1i(gl.getUniformLocation(pr, 'v'), 0); gl.uniform1i(gl.getUniformLocation(pr, 'm'), 1);
    gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1);
    const vid = document.createElement('video');
    vid.muted = true; vid.loop = true; vid.playsInline = true; vid.preload = 'auto';
    vid.setAttribute('muted', ''); vid.setAttribute('playsinline', ''); vid.src = src;
    const mc = document.createElement('canvas'), mx = mc.getContext('2d', { willReadFrequently: true });
    let mw = 0, mh = 0, seen, q, out, lastT = -1, playing = false;
    const L = { canvas: cv, video: vid, onfirst: null, drawn: false, n: 0 };
    function mask() {
      if (!mw) { mw = MW; mh = Math.round(MW * vid.videoHeight / vid.videoWidth); mc.width = mw; mc.height = mh; seen = new Uint8Array(mw * mh); q = new Int32Array(mw * mh); out = new Uint8Array(mw * mh); }
      mx.drawImage(vid, 0, 0, mw, mh); const d = mx.getImageData(0, 0, mw, mh).data, n = mw * mh; seen.fill(0);
      let qh = 0, qt = 0;
      const push = i => { if (seen[i]) return; const p = i * 4; if (d[p] < T && d[p + 1] < T && d[p + 2] < T) { seen[i] = 1; q[qt++] = i; } };
      for (let x = 0; x < mw; x++) { push(x); push((mh - 1) * mw + x); }
      for (let y = 0; y < mh; y++) { push(y * mw); push(y * mw + mw - 1); }
      while (qh < qt) { const i = q[qh++], x = i % mw; if (x > 0) push(i - 1); if (x < mw - 1) push(i + 1); if (i >= mw) push(i - mw); if (i < n - mw) push(i + mw); }
      for (let i = 0; i < n; i++) out[i] = seen[i] ? 0 : 255;
      gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D, tm);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, mw, mh, 0, gl.LUMINANCE, gl.UNSIGNED_BYTE, out);
    }
    function draw() {
      if (!vid.videoWidth || vid.readyState < 2) return;
      if (!cv.width || cv.width === 300) { cv.width = Math.min(1100, vid.videoWidth); cv.height = Math.round(cv.width * vid.videoHeight / vid.videoWidth); }
      gl.viewport(0, 0, cv.width, cv.height);
      gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, tv);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, vid);
      if (!(L.n++ % 2)) mask();
      gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT); gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      if (!L.drawn) { L.drawn = true; L.onfirst && L.onfirst(); }
    }
    const rvfc = 'requestVideoFrameCallback' in HTMLVideoElement.prototype;
    function tick() { if (!playing) return; if (rvfc) vid.requestVideoFrameCallback(() => { draw(); tick(); }); else requestAnimationFrame(() => { if (vid.currentTime !== lastT) { lastT = vid.currentTime; draw(); } tick(); }); }
    vid.addEventListener('loadeddata', () => draw());
    L.play = () => { if (playing) return; playing = true; const p = vid.play(); p && p.catch(() => {}); tick(); };
    L.pause = () => { playing = false; vid.pause(); };
    return L;
  };
})();

/* PUFF engine bundle (generated from the puff-*.js sources, in load order). Vanilla JS, Shopify-ready. */

/* ---- puff-sky.js ---- */
/* PUFF polygon sky — <puff-sky> custom element. Vanilla JS, no deps (Shopify-ready).
   Attributes: aura (id), orientation (portrait|landscape), origin ("fx,fy" ripple origin, fractions of the element box),
   order (ripple|top|random), tile-style (flip|fade), wave (ms), tile (ms), twinkle (on|off), seed */
(function () {
  if (window.PuffSky) return;
  const AURAS = [
    { id: 'red', name: 'Red', pantone: '185 C', hex: '#E4002B', meaning: ['PASSION', 'POWER', 'FIRE'], edge: 'spikes' },
    { id: 'orange', name: 'Orange', pantone: '151 C', hex: '#FF8200', meaning: ['ENERGY', 'CREATIVITY', 'DESIRE'], edge: 'flames' },
    { id: 'yellow', name: 'Yellow', pantone: 'Yellow C', hex: '#FEDD00', meaning: ['CONFIDENCE', 'RADIANCE', 'JOY'], edge: 'rays' },
    { id: 'green', name: 'Green', pantone: '368 C', hex: '#78BE20', meaning: ['GROWTH', 'BALANCE', 'HEALING'], edge: 'vines' },
    { id: 'sky-blue', name: 'Sky Blue', pantone: 'Brand', hex: '#3ED5FF', meaning: ['CALMNESS', 'WISDOM', 'HONESTY'], edge: 'scallops' },
    { id: 'blue', name: 'Blue', pantone: '300 C', hex: '#005EB8', meaning: ['INTUITION', 'MYSTERY', 'DEPTH'], edge: 'wisps' },
    { id: 'purple', name: 'Purple', pantone: '265 C', hex: '#9063CD', meaning: ['SPIRITUALITY', 'DEDICATION', 'INFLUENCE'], edge: 'smoke' },
  ];
  const lin = c => (c /= 255) <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  const unlin = c => Math.max(0, Math.min(255, Math.round((c <= 0.0031308 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055) * 255)));
  function toLab(hex) {
    const n = parseInt(hex.slice(1), 16), r = lin(n >> 16 & 255), g = lin(n >> 8 & 255), b = lin(n & 255);
    const l = Math.cbrt(0.4122214708 * r + 0.5363325363 * g + 0.0514459929 * b);
    const m = Math.cbrt(0.2119034982 * r + 0.6806995451 * g + 0.1073969566 * b);
    const s = Math.cbrt(0.0883024619 * r + 0.2817188376 * g + 0.6299787005 * b);
    return [0.2104542553 * l + 0.793617785 * m - 0.0040720468 * s, 1.9779984951 * l - 2.428592205 * m + 0.4505937099 * s, 0.0259040371 * l + 0.7827717662 * m - 0.808675766 * s];
  }
  function toHex([L, A, B]) {
    const l = (L + 0.3963377774 * A + 0.2158037573 * B) ** 3, m = (L - 0.1055613458 * A - 0.0638541728 * B) ** 3, s = (L - 0.0894841775 * A - 1.291485548 * B) ** 3;
    const r = unlin(4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s), g = unlin(-1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s), b = unlin(-0.0041960863 * l - 0.7034186147 * m + 1.707614701 * s);
    return '#' + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1);
  }
  const mixLab = (a, b, t) => [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t];
  const mix = (h1, h2, t) => toHex(mixLab(toLab(h1), toLab(h2), t));
  // Sky Blue = the live sky, sampled top → bottom
  const SKY = [[0, '#1CB6E3'], [.1, '#27BEE9'], [.22, '#35C5EF'], [.32, '#3EC7F1'], [.42, '#52CDF3'], [.52, '#6FD5F6'], [.62, '#8CDDF7'], [.7, '#A0E4F7'], [.8, '#D1F2FC'], [.9, '#ECF9FD'], [1, '#FCFEFF']];
  const ramps = {};
  function rampFor(id) {
    if (ramps[id]) return ramps[id];
    const a = AURAS.find(x => x.id === id) || AURAS[4];
    let stops;
    if (a.id === 'sky-blue') stops = SKY;
    else {
      const lab = toLab(a.hex), top = [Math.max(0.2, lab[0] - 0.09), lab[1] * 1.05, lab[2] * 1.05];
      stops = [[0, toHex(top)], [.3, a.hex], [.66, mix(a.hex, '#ffffff', 0.58)], [.88, mix(a.hex, '#ffffff', 0.86)], [1, mix(a.hex, '#ffffff', 0.97)]];
    }
    return (ramps[id] = stops.map(([t, h]) => [t, toLab(h)]));
  }
  function colorAt(id, t) {
    const r = rampFor(id); t = Math.max(0, Math.min(1, t));
    for (let i = 1; i < r.length; i++) if (t <= r[i][0]) { const [t0, c0] = r[i - 1], [t1, c1] = r[i]; return toHex(mixLab(c0, c1, (t - t0) / (t1 - t0 || 1))); }
    return toHex(r[r.length - 1][1]);
  }
  function rng(seed) { let a = seed >>> 0; return () => { a = a + 0x6D2B79F5 | 0; let t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function clip(poly, nx, ny, c) { // keep n·p <= c
    const out = [];
    for (let i = 0; i < poly.length; i++) {
      const p = poly[i], q = poly[(i + 1) % poly.length], dp = nx * p[0] + ny * p[1] - c, dq = nx * q[0] + ny * q[1] - c;
      if (dp <= 0) out.push(p);
      if ((dp <= 0) !== (dq <= 0)) { const t = dp / (dp - dq); out.push([p[0] + (q[0] - p[0]) * t, p[1] + (q[1] - p[1]) * t]); }
    }
    return out;
  }
  function centroid(poly) {
    let a = 0, x = 0, y = 0;
    for (let i = 0; i < poly.length; i++) { const p = poly[i], q = poly[(i + 1) % poly.length], k = p[0] * q[1] - q[0] * p[1]; a += k; x += (p[0] + q[0]) * k; y += (p[1] + q[1]) * k; }
    return a ? [x / (3 * a), y / (3 * a)] : poly[0];
  }
  const geoCache = {};
  function buildSky(portrait, seed) {
    const key = (portrait ? 'p' : 'l') + seed; if (geoCache[key]) return geoCache[key];
    const W = portrait ? 1920 : 2560, H = portrait ? 3400 : 1440, cols = portrait ? 7 : 9, rows = portrait ? 11 : 6, R = rng(seed);
    let seeds = [];
    for (let j = 0; j < rows; j++) for (let i = 0; i < cols; i++) seeds.push([(i + 0.15 + R() * 0.7) * W / cols, (j + 0.15 + R() * 0.7) * H / rows]);
    let cells;
    for (let it = 0; it < 2; it++) {
      cells = seeds.map((s, i) => {
        let poly = [[0, 0], [W, 0], [W, H], [0, H]];
        for (let j = 0; j < seeds.length && poly.length; j++) if (j !== i) {
          const o = seeds[j], nx = o[0] - s[0], ny = o[1] - s[1];
          poly = clip(poly, nx, ny, nx * (s[0] + o[0]) / 2 + ny * (s[1] + o[1]) / 2);
        }
        return poly;
      });
      if (it < 1) seeds = cells.map((p, i) => p.length ? centroid(p) : seeds[i]);
    }
    const tiles = cells.map((poly, i) => { const c = centroid(poly); return { poly, cx: c[0], cy: c[1], t: Math.max(0, Math.min(1, c[1] / H + (R() * 2 - 1) * 0.075)), r: R() }; });
    return (geoCache[key] = { W, H, tiles });
  }
  const SVGNS = 'http://www.w3.org/2000/svg';
  const reduce = () => window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  class PuffSkyEl extends HTMLElement {
    static get observedAttributes() { return ['aura', 'orientation', 'twinkle']; }
    connectedCallback() {
      if (!this._init) {
        this._init = true;
        this.style.display = this.style.display || 'block';
        if (!this.style.width) this.style.width = '100%';
        if (!this.style.height) this.style.height = '100%';
        this.style.overflow = 'hidden';
        this.build();
      }
      this.startTwinkle();
    }
    disconnectedCallback() { clearInterval(this._tw); }
    attributeChangedCallback(n, o, v) {
      if (!this._init || o === v) return;
      if (n === 'aura') this.setAura(v, true);
      else if (n === 'orientation') this.build();
      else if (n === 'twinkle') this.startTwinkle();
    }
    build() {
      const portrait = (this.getAttribute('orientation') || 'portrait') !== 'landscape';
      const geo = buildSky(portrait, +(this.getAttribute('seed') || (portrait ? 77 : 54)));
      this.geo = geo; this.aura = this.getAttribute('aura') || 'sky-blue';
      const svg = document.createElementNS(SVGNS, 'svg');
      svg.setAttribute('viewBox', `0 0 ${geo.W} ${geo.H}`);
      svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
      svg.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;display:block';
      this.els = geo.tiles.map(t => {
        const p = document.createElementNS(SVGNS, 'polygon'), c = colorAt(this.aura, t.t);
        p.setAttribute('points', t.poly.map(q => q[0].toFixed(1) + ',' + q[1].toFixed(1)).join(' '));
        p.style.cssText = `fill:${c};stroke:${c};stroke-width:3;stroke-linejoin:round;transform-box:fill-box;transform-origin:center`;
        svg.appendChild(p); return p;
      });
      this.ring = document.createElementNS(SVGNS, 'circle');
      this.ring.setAttribute('fill', 'none'); this.ring.setAttribute('stroke', '#ffffff'); this.ring.setAttribute('r', '0'); this.ring.style.opacity = '0';
      svg.appendChild(this.ring);
      this.innerHTML = ''; if (getComputedStyle(this).position === 'static') this.style.position = 'relative';
      this.appendChild(svg); this.svg = svg;
    }
    toView(fx, fy) {
      const b = this.getBoundingClientRect(), { W, H } = this.geo;
      if (!b.width || !b.height) return [fx * W, fy * H];
      const s = Math.max(b.width / W, b.height / H), vw = b.width / s, vh = b.height / s;
      return [(W - vw) / 2 + fx * vw, (H - vh) / 2 + fy * vh];
    }
    setAura(id, animate) {
      if (!this.els) return;
      this.aura = id;
      const tiles = this.geo.tiles, instant = !animate || reduce();
      const order = this.getAttribute('order') || 'ripple', flip = this.getAttribute('tile-style') === 'flip';
      const wave = +(this.getAttribute('wave') || 650), dur = +(this.getAttribute('tile') || (flip ? 225 : 340));
      const og = (this.getAttribute('origin') || '0.5,0.45').split(',').map(Number), [ox, oy] = this.toView(og[0], og[1]);
      let maxD = 1; const dists = tiles.map(t => { const d = Math.hypot(t.cx - ox, t.cy - oy); if (d > maxD) maxD = d; return d; });
      tiles.forEach((t, i) => {
        const el = this.els[i], to = colorAt(id, t.t);
        if (t.tw) { t.tw.cancel(); t.tw = null; }
        if (instant) { if (t.anim) t.anim.cancel(); el.style.fill = el.style.stroke = to; return; }
        const from = getComputedStyle(el).fill;
        if (t.anim) t.anim.cancel();
        el.style.fill = el.style.stroke = to;
        const delay = order === 'top' ? (t.cy / this.geo.H) * wave : order === 'random' ? t.r * wave : (dists[i] / maxD) * wave;
        const glint = mix(to, '#ffffff', 0.4);
        const kf = flip
          ? [{ fill: from, stroke: from, transform: 'scale(1,1)' }, { fill: from, stroke: from, transform: 'scale(1,0.04)', offset: 0.5 }, { fill: glint, stroke: glint, transform: 'scale(1,0.04)', offset: 0.501 }, { fill: to, stroke: to, transform: 'scale(1,1)' }]
          : [{ fill: from, stroke: from }, { fill: to, stroke: to }];
        t.anim = el.animate(kf, { duration: dur, delay, easing: flip ? 'cubic-bezier(.5,0,.3,1)' : 'ease-in-out', fill: 'backwards' });
      });
      if (!instant && order === 'ripple' && this.getAttribute('ring') === 'on') {
        this.ring.setAttribute('cx', ox); this.ring.setAttribute('cy', oy);
        if (this.ringAnim) this.ringAnim.cancel();
        this.ringAnim = this.ring.animate([{ r: 0, strokeWidth: 60, opacity: 0.7 }, { r: maxD * 1.05, strokeWidth: 6, opacity: 0 }], { duration: wave + dur, easing: 'cubic-bezier(.2,.6,.4,1)' });
      }
    }
    startTwinkle() {
      clearInterval(this._tw);
      if ((this.getAttribute('twinkle') || 'on') === 'off' || reduce()) return;
      this._tw = setInterval(() => {
        if (!this.els || document.hidden) return;
        const i = Math.floor(Math.random() * this.els.length), t = this.geo.tiles[i];
        if (t.tw || (t.anim && t.anim.playState === 'running')) return;
        const base = colorAt(this.aura, t.t), hi = mix(base, '#ffffff', 0.28);
        t.tw = this.els[i].animate([{ fill: base, stroke: base }, { fill: hi, stroke: hi, offset: 0.35 }, { fill: base, stroke: base }], { duration: 1600, easing: 'ease-in-out' });
        t.tw.onfinish = () => { t.tw = null; };
      }, 420);
    }
  }
  window.PuffSky = { AURAS, rampFor, colorAt, mix, toLab, toHex };
  customElements.define('puff-sky', PuffSkyEl);
})();


/* ---- puff-contour.js ---- */
/* PUFF aura engine, part 1: silhouette contour from a cut-out's alpha. Vanilla JS.
   Frame units: the model box is 1080 x 2340 (9:19.5). The aura canvas covers x -0.3W..1.3W, y -0.1H..H. */
(function () {
  if (window.PuffContour) return;
  const FW = 1080, FH = 2340, AX = -0.3 * FW, AY = -0.1 * FH, AW = 1.6 * FW, AH = 1.1 * FH;
  const GW = 128, CELL = AW / GW, GH = Math.round(AH / CELL);
  const cache = new Map();

  function chamfer(mask, w, h) { // distance (x3 units) to nearest inside cell
    const INF = 1e9, d = new Float32Array(w * h);
    for (let i = 0; i < w * h; i++) d[i] = mask[i] ? 0 : INF;
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
      const i = y * w + x; let v = d[i];
      if (x > 0) v = Math.min(v, d[i - 1] + 3);
      if (y > 0) { v = Math.min(v, d[i - w] + 3); if (x > 0) v = Math.min(v, d[i - w - 1] + 4); if (x < w - 1) v = Math.min(v, d[i - w + 1] + 4); }
      d[i] = v;
    }
    for (let y = h - 1; y >= 0; y--) for (let x = w - 1; x >= 0; x--) {
      const i = y * w + x; let v = d[i];
      if (x < w - 1) v = Math.min(v, d[i + 1] + 3);
      if (y < h - 1) { v = Math.min(v, d[i + w] + 3); if (x < w - 1) v = Math.min(v, d[i + w + 1] + 4); if (x > 0) v = Math.min(v, d[i + w - 1] + 4); }
      d[i] = v;
    }
    return d;
  }

  function trace(m, w, h) { // Moore-neighbour outer boundary, clockwise on screen
    let s = -1; for (let i = 0; i < w * h; i++) if (m[i]) { s = i; break; }
    if (s < 0) return [];
    const dx = [-1, -1, 0, 1, 1, 1, 0, -1], dy = [0, -1, -1, -1, 0, 1, 1, 1];
    const sx = s % w, sy = (s / w) | 0, pts = [[sx, sy]];
    let cx = sx, cy = sy, back = 0, guard = 0;
    const inside = (x, y) => x >= 0 && y >= 0 && x < w && y < h && m[y * w + x];
    while (guard++ < w * h * 3) {
      let moved = false;
      for (let k = 1; k <= 8; k++) {
        const d = (back + k) % 8, nx = cx + dx[d], ny = cy + dy[d];
        if (inside(nx, ny)) { cx = nx; cy = ny; back = d % 2 ? (d + 5) % 8 : (d + 6) % 8; moved = true; break; }
      }
      if (!moved || (cx === sx && cy === sy)) break;
      pts.push([cx, cy]);
    }
    return pts;
  }

  function resample(pts, step) {
    const out = [[pts[0][0], pts[0][1]]]; let acc = 0;
    for (let i = 1; i < pts.length; i++) {
      let [x0, y0] = pts[i - 1]; const [x1, y1] = pts[i]; let seg = Math.hypot(x1 - x0, y1 - y0);
      while (acc + seg >= step) { const t = (step - acc) / seg; x0 += (x1 - x0) * t; y0 += (y1 - y0) * t; out.push([x0, y0]); seg = Math.hypot(x1 - x0, y1 - y0); acc = 0; }
      acc += seg;
    }
    return out;
  }
  function smooth(p, win) {
    const n = p.length, o = new Array(n), h = win >> 1;
    for (let i = 0; i < n; i++) { let x = 0, y = 0, c = 0; for (let k = -h; k <= h; k++) { const j = Math.max(0, Math.min(n - 1, i + k)); x += p[j][0]; y += p[j][1]; c++; } o[i] = [x / c, y / c]; }
    return o;
  }

  /* img: loaded HTMLImageElement; rect: placement of the image in frame units {x,y,w,h}; gap: aura offset from body in frame units */
  function contour(img, rect, gap, key) {
    const k = key + '|' + gap; if (cache.has(k)) return cache.get(k);
    const H = GH + 4, c = document.createElement('canvas'); c.width = GW; c.height = GH;
    const g = c.getContext('2d', { willReadFrequently: true });
    g.drawImage(img, (rect.x - AX) / CELL, (rect.y - AY) / CELL, rect.w / CELL, rect.h / CELL);
    const a = g.getImageData(0, 0, GW, GH).data, mask = new Uint8Array(GW * H);
    for (let y = 0; y < H; y++) for (let x = 0; x < GW; x++) mask[y * GW + x] = a[(Math.min(y, GH - 1) * GW + x) * 4 + 3] > 110 ? 1 : 0;
    const dist = chamfer(mask, GW, H), lim = 3 * gap / CELL, dil = new Uint8Array(GW * H);
    for (let i = 0; i < dil.length; i++) dil[i] = dist[i] <= lim ? 1 : 0;
    let raw = trace(dil, GW, H);
    if (raw.length < 8) { cache.set(k, null); return null; }
    // open the loop at the frame bottom: keep the run of points above the bottom edge
    const above = p => p[1] < GH - 1.5;
    let start = raw.findIndex((p, i) => above(p) && !above(raw[(i - 1 + raw.length) % raw.length]));
    if (start < 0) start = 0;
    const run = [];
    for (let i = 0; i < raw.length; i++) { const p = raw[(start + i) % raw.length]; if (!above(p)) { if (run.length) break; else continue; } run.push(p); }
    let pts = smooth(smooth(resample(run, 1.2), 9), 7);
    pts = pts.map(([x, y]) => [x * CELL + AX, y * CELL + AY]);
    const n = pts.length, nrm = new Array(n);
    for (let i = 0; i < n; i++) {
      const p = pts[Math.max(0, i - 2)], q = pts[Math.min(n - 1, i + 2)], tx = q[0] - p[0], ty = q[1] - p[1], l = Math.hypot(tx, ty) || 1;
      nrm[i] = [ty / l, -tx / l];
    }
    const step = 1.2 * CELL, res = { pts, nrm, n, step, len: n * step };
    cache.set(k, res); return res;
  }
  window.PuffContour = { contour, FW, FH, AX, AY, AW, AH };
})();


/* ---- puff-grammar-a.js ---- */
/* PUFF aura engine, part 2a: helpers + spikes (red), flames (orange), rays (yellow), scallops (sky blue). Vanilla JS. */
(function () {
  const G = window.PuffGrammar = window.PuffGrammar || {};
  const hash = n => { const s = Math.sin(n * 127.1 + 311.7) * 43758.5453; return s - Math.floor(s); };
  const noise = x => { const i = Math.floor(x), f = x - i, u = f * f * (3 - 2 * f); return hash(i) * (1 - u) + hash(i + 1) * u; };
  // sample contour at arc length s (clamped): returns [x, y, nx, ny, tx, ty]
  function at(C, s) {
    const f = Math.max(0, Math.min(C.n - 1.001, s / C.step)), i = Math.floor(f), u = f - i, p = C.pts[i], q = C.pts[i + 1] || p, a = C.nrm[i], b = C.nrm[i + 1] || a;
    let nx = a[0] + (b[0] - a[0]) * u, ny = a[1] + (b[1] - a[1]) * u; const l = Math.hypot(nx, ny) || 1; nx /= l; ny /= l;
    return [p[0] + (q[0] - p[0]) * u, p[1] + (q[1] - p[1]) * u, nx, ny, -ny, nx];
  }
  const off = (P, d, side) => [P[0] + P[2] * d + P[4] * (side || 0), P[1] + P[3] * d + P[5] * (side || 0)];
  // close an outline path down along the frame bottom so the field fills behind the legs
  function closeBottom(ctx, C, first, last) {
    const FH = window.PuffContour.FH;
    ctx.lineTo(last[0], FH + 80); ctx.lineTo(first[0], FH + 80); ctx.closePath();
  }
  function finish(ctx, col, w, join) {
    ctx.fillStyle = col.field; ctx.fill();
    ctx.lineJoin = join || 'round'; ctx.lineCap = 'round'; ctx.miterLimit = 12;
    ctx.strokeStyle = col.stroke; ctx.lineWidth = w; ctx.stroke();
  }
  G.util = { hash, noise, at, off, closeBottom, finish };

  G.spikes = (ctx, C, col, t, k) => { // jagged starburst: straight zigzag, no curves, spikes jump at 9fps, red glow inside
    const sp = 52, tb = Math.floor(t * 9), drift = (t * 16) % sp, n = Math.ceil(C.len / sp) + 1;
    ctx.beginPath(); let first, last;
    for (let i = 0; i <= n * 2; i++) {
      const s = Math.min(C.len, i * sp / 2 + (i ? drift : 0)), P = at(C, s);
      const L = i % 2 ? (58 + 96 * noise(i * 0.83 + tb * 0.61)) * k : 10 + 8 * hash(i + tb);
      const q = off(P, L, i % 2 ? (hash(i + tb) - 0.5) * 18 : 0);
      if (!i) { ctx.moveTo(q[0], q[1]); first = q; } else ctx.lineTo(q[0], q[1]);
      last = q; if (s >= C.len) break;
    }
    closeBottom(ctx, C, first, last);
    ctx.fillStyle = 'rgba(255,72,92,0.30)'; ctx.fill();
    ctx.lineJoin = 'miter'; ctx.miterLimit = 14;
    ctx.globalAlpha *= 0.22; ctx.strokeStyle = col.stroke; ctx.lineWidth = 54; ctx.stroke(); ctx.globalAlpha /= 0.22;
    ctx.lineWidth = 22; ctx.stroke();
    ctx.strokeStyle = 'rgba(255,255,255,0.35)'; ctx.lineWidth = 4; ctx.stroke();
  };

  G.flames = (ctx, C, col, t, k) => { // tapered licks with hooked tips, leaning upward
    const sp = 66, drift = (t * 18) % sp, n = Math.ceil(C.len / sp) + 1;
    ctx.beginPath(); let first, last;
    for (let i = 0; i <= n; i++) {
      const s0 = i ? Math.min(C.len, i * sp - drift) : 0, s1 = Math.min(C.len, (i + 1) * sp - drift);
      const A = at(C, Math.max(0, s0)), B = at(C, s1), M = at(C, (Math.max(0, s0) + s1) / 2);
      let dx = M[2], dy = M[3] - 0.75; const l = Math.hypot(dx, dy) || 1; dx /= l; dy /= l;
      const L = (54 + 64 * noise(i * 1.31 + t * 1.7)) * k, hook = Math.sin(t * 3.1 + i * 1.7) * 20 * k;
      const tip = [M[0] + dx * L + M[4] * hook, M[1] + dy * L + M[5] * hook];
      const a = off(A, 3), b = off(B, 3);
      if (!i) { ctx.moveTo(a[0], a[1]); first = a; }
      ctx.quadraticCurveTo(a[0] + dx * L * 0.6 - M[4] * 8, a[1] + dy * L * 0.6 - M[5] * 8, tip[0], tip[1]);
      ctx.quadraticCurveTo(tip[0] - M[4] * hook * 0.9 - dx * 6, tip[1] - M[5] * hook * 0.9 - dy * 6, tip[0] - dx * L * 0.25 + M[4] * 10, tip[1] - dy * L * 0.25 + M[5] * 10);
      ctx.quadraticCurveTo(b[0] + dx * L * 0.3, b[1] + dy * L * 0.3, b[0], b[1]);
      last = b; if (s1 >= C.len) break;
    }
    closeBottom(ctx, C, first, last); finish(ctx, col, 20);
  };

  G.rays = (ctx, C, col, t, k) => { // sunburst: long thin straight rays + a smooth rim
    ctx.beginPath(); let first, last;
    for (let s = 0; s <= C.len; s += 10) { const q = off(at(C, s), 6 + 4 * Math.sin(s * 0.05 - t * 3)); if (!s) { ctx.moveTo(q[0], q[1]); first = q; } else ctx.lineTo(q[0], q[1]); last = q; }
    closeBottom(ctx, C, first, last); finish(ctx, col, 12);
    const sp = 24, n = Math.floor(C.len / sp), spin = t * 22;
    ctx.fillStyle = col.stroke; ctx.beginPath();
    for (let i = 1; i < n; i++) {
      const s = (i * sp + spin) % C.len, P = at(C, s), wave = 0.5 + 0.5 * Math.sin(s * 0.018 - t * 4.2);
      const L = ((i % 2 ? 46 : 92) + 70 * wave * noise(i * 0.7 + t)) * k, w = i % 2 ? 4 : 6.5;
      const b0 = off(P, 8, -w), b1 = off(P, 8, w), tip = off(P, 8 + L);
      ctx.moveTo(b0[0], b0[1]); ctx.lineTo(tip[0], tip[1]); ctx.lineTo(b1[0], b1[1]); ctx.closePath();
    }
    ctx.fill();
  };

  G.scallops = (ctx, C, col, t, k) => { // bubbly cloud lobes that breathe
    ctx.beginPath(); let s = 0, i = 0, first, last;
    const P0 = off(at(C, 0), 2); ctx.moveTo(P0[0], P0[1]); first = P0;
    while (s < C.len && i < 400) {
      const w = 58 + 52 * hash(i * 3.7), s1 = Math.min(C.len, s + w), A = at(C, s), B = at(C, s1);
      const h = (w / 2) * 1.33 * (0.82 + 0.18 * Math.sin(t * 2.2 + i * 1.9)) * (0.4 + 0.6 * k);
      const a = off(A, 2), b = off(B, 2);
      ctx.bezierCurveTo(a[0] + A[2] * h, a[1] + A[3] * h, b[0] + B[2] * h, b[1] + B[3] * h, b[0], b[1]);
      last = b; s = s1; i++;
    }
    closeBottom(ctx, C, first, last); finish(ctx, col, 20);
  };
})();


/* ---- puff-grammar-b.js ---- */
/* PUFF aura engine, part 2b: vines (green), wisps (blue), smoke (purple) + per-colour particles. Vanilla JS. */
(function () {
  const G = window.PuffGrammar, { hash, noise, at, off, closeBottom, finish } = G.util;

  function leaf(ctx, x, y, ang, len, wid) {
    const c = Math.cos(ang), s = Math.sin(ang), tx = x + c * len, ty = y + s * len, px = -s * wid, py = c * wid, mx = x + c * len * 0.5, my = y + s * len * 0.5;
    ctx.moveTo(x, y); ctx.quadraticCurveTo(mx + px, my + py, tx, ty); ctx.quadraticCurveTo(mx - px, my - py, x, y);
  }

  G.vines = (ctx, C, col, t, k) => { // wavy vine rim + curling tendrils with spiral ends + pointed leaves
    ctx.beginPath(); let first, last;
    for (let s = 0; s <= C.len; s += 9) { const q = off(at(C, s), 8 + 7 * Math.sin(s * 0.035 + t * 1.3)); if (!s) { ctx.moveTo(q[0], q[1]); first = q; } else ctx.lineTo(q[0], q[1]); last = q; }
    closeBottom(ctx, C, first, last); finish(ctx, col, 13);
    const sp = 128, n = Math.floor(C.len / sp);
    ctx.strokeStyle = col.stroke; ctx.lineWidth = 9; ctx.lineCap = 'round';
    for (let i = 0; i < n; i++) {
      const s = i * sp + sp * 0.5, P = at(C, s), side = i % 2 ? 1 : -1, grow = Math.min(1, k * (1.15 - 0.15 * hash(i)));
      const sway = Math.sin(t * 1.4 + i * 2.1) * 0.35, base = off(P, 10), Q = off(P, 10 + 58 * grow, side * 26 * grow);
      const a0 = Math.atan2(Q[1] - base[1], Q[0] - base[0]) + side * 1.4 + sway, R = 24 * grow;
      ctx.beginPath(); ctx.moveTo(base[0], base[1]);
      ctx.quadraticCurveTo(base[0] + P[2] * 46 * grow, base[1] + P[3] * 46 * grow, Q[0], Q[1]);
      for (let u = 0; u <= 1.001; u += 0.06) { const r = R * Math.pow(1 - u, 1.25) + 2, a = a0 + side * u * Math.PI * 2.6; ctx.lineTo(Q[0] + Math.cos(a) * r - Math.cos(a0) * R, Q[1] + Math.sin(a) * r - Math.sin(a0) * R); }
      ctx.stroke();
    }
    ctx.fillStyle = col.stroke; ctx.beginPath();
    for (let i = 0; i < n * 2; i++) {
      const s = i * sp / 2 + 30, P = at(C, s), ang = Math.atan2(P[3], P[2]) + (i % 2 ? 0.7 : -0.7) + Math.sin(t * 2 + i) * 0.15;
      const q = off(P, 9); leaf(ctx, q[0], q[1], ang, 30 * k, 9 * k);
    }
    ctx.fill();
  };

  G.wisps = (ctx, C, col, t, k) => { // S-curved tongues with rolled, hooked tips
    const sp = 84, drift = (t * 24) % sp, n = Math.ceil(C.len / sp) + 1;
    ctx.beginPath(); let first, last;
    for (let i = 0; i <= n; i++) {
      const s0 = i ? Math.min(C.len, i * sp - drift) : 0, s1 = Math.min(C.len, (i + 1) * sp - drift);
      const A = at(C, s0), B = at(C, s1), M = at(C, (s0 + s1) / 2);
      const L = (64 + 58 * noise(i * 1.13 + t * 1.2)) * k, sw = Math.sin(t * 2.3 + i * 1.6) * 16 * k;
      const a = off(A, 3), b = off(B, 3), tip = off(M, L, sw), curl = 11 * k;
      if (!i) { ctx.moveTo(a[0], a[1]); first = a; }
      const c1 = off(A, L * 0.45, 22), c2 = off(M, L * 0.7, -26 + sw);
      ctx.bezierCurveTo(c1[0], c1[1], c2[0], c2[1], tip[0], tip[1]);
      const ang = Math.atan2(M[5], M[4]);
      ctx.arc(tip[0] + M[4] * curl, tip[1] + M[5] * curl, curl, ang + Math.PI, ang + Math.PI * 2.2, false);
      const c3 = off(M, L * 0.35, 20), c4 = off(B, L * 0.2, -14);
      ctx.bezierCurveTo(c3[0], c3[1], c4[0], c4[1], b[0], b[1]);
      last = b; if (s1 >= C.len) break;
    }
    closeBottom(ctx, C, first, last); finish(ctx, col, 14);
  };

  G.smoke = (ctx, C, col, t, k) => { // broad soft rounded lobes drifting upward, two layers
    for (let layer = 0; layer < 2; layer++) {
      ctx.beginPath(); let s = 0, i = 0, first, last;
      const drift = (t * (layer ? 16 : 10)) % 120, P0 = off(at(C, 0), 2); ctx.moveTo(P0[0], P0[1]); first = P0;
      while (s < C.len && i < 200) {
        const w = (layer ? 92 : 120) + 50 * hash(i * 5.3 + layer), s1 = Math.min(C.len, s + w - (i ? 0 : drift % w));
        const A = at(C, s), B = at(C, s1), lean = -0.5;
        const h = w * (0.55 + 0.22 * Math.sin(t * 1.1 + i * 1.7 + layer)) * (0.35 + 0.65 * k) * (layer ? 0.8 : 1.15);
        const a = off(A, 2), b = off(B, 2);
        ctx.bezierCurveTo(a[0] + A[2] * h, a[1] + (A[3] + lean) * h, b[0] + B[2] * h, b[1] + (B[3] + lean) * h, b[0], b[1]);
        last = b; s = s1; i++;
      }
      closeBottom(ctx, C, first, last);
      if (layer) finish(ctx, col, 14); else { ctx.fillStyle = col.halo; ctx.fill(); }
    }
  };

  // stateless particles: a pure function of time, so they survive re-renders and cost nothing to keep
  G.particles = (ctx, C, col, edge, t, k) => {
    const N = 22; ctx.fillStyle = col.stroke; ctx.strokeStyle = col.stroke;
    for (let i = 0; i < N; i++) {
      const per = 1.6 + hash(i) * 1.6, ph = t / per + hash(i * 9.1), cyc = Math.floor(ph), u = ph - cyc;
      const P = at(C, hash(i * 3.3 + cyc * 7.7) * C.len), d = 30 + u * (edge === 'rays' ? 190 : 130), rise = edge === 'smoke' || edge === 'flames' ? -u * 70 : 0;
      const x = P[0] + P[2] * d, y = P[1] + P[3] * d + rise, a = Math.sin(u * Math.PI) * k, sz = (6 + 10 * hash(i * 1.7)) * (edge === 'smoke' ? 1.8 : 1);
      if (a <= 0.02) continue;
      ctx.globalAlpha = a; ctx.beginPath();
      if (edge === 'spikes') { const r = Math.atan2(P[3], P[2]); ctx.moveTo(x + Math.cos(r) * sz * 1.6, y + Math.sin(r) * sz * 1.6); ctx.lineTo(x + Math.cos(r + 2.4) * sz * 0.6, y + Math.sin(r + 2.4) * sz * 0.6); ctx.lineTo(x + Math.cos(r - 2.4) * sz * 0.6, y + Math.sin(r - 2.4) * sz * 0.6); ctx.fill(); }
      else if (edge === 'rays') { for (let q = 0; q < 4; q++) { const r = q * Math.PI / 2 + t; ctx.moveTo(x, y); ctx.lineTo(x + Math.cos(r) * sz, y + Math.sin(r) * sz); } ctx.lineWidth = 3; ctx.stroke(); }
      else if (edge === 'vines') { leaf(ctx, x, y, t * 2 + i, sz * 1.8, sz * 0.6); ctx.fill(); }
      else if (edge === 'scallops') { ctx.arc(x, y, sz * 0.8, 0, Math.PI * 2); ctx.fillStyle = col.field; ctx.fill(); ctx.lineWidth = 4; ctx.stroke(); ctx.fillStyle = col.stroke; }
      else if (edge === 'wisps') { ctx.arc(x, y, sz, 0, Math.PI * 1.4); ctx.lineWidth = 4; ctx.stroke(); }
      else { ctx.arc(x, y, sz * (edge === 'smoke' ? 1 : 0.55), 0, Math.PI * 2); if (edge === 'smoke') { ctx.fillStyle = col.halo; ctx.fill(); ctx.fillStyle = col.stroke; } else ctx.fill(); }
    }
    ctx.globalAlpha = 1;
  };
})();


/* ---- puff-edge.js ---- */
/* PUFF aura edge renderer: draws one frame of the aura radiation around the current cut-out. Vanilla JS. */
(function () {
  if (window.PuffEdge) return;
  const cols = {};
  function colors(id) {
    if (cols[id]) return cols[id];
    const S = window.PuffSky, a = S.AURAS.find(x => x.id === id) || S.AURAS[4];
    if (a.id === 'sky-blue') return (cols[id] = { stroke: '#10ADE6', field: '#E4F8FF', halo: '#C2EEFF' });
    const lab = S.toLab(a.hex);
    return (cols[id] = { stroke: S.toHex([lab[0] - 0.07, lab[1] * 1.08, lab[2] * 1.08]), field: S.mix(a.hex, '#ffffff', 0.8), halo: S.mix(a.hex, '#ffffff', 0.6) });
  }
  const easeOutBack = x => { const c1 = 1.70158, c3 = c1 + 1; return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2); };
  /* st: { canvas, boxW, boxH, contour, auraId, edge, t, grow (0..1), alpha, rings } */
  function render(st) {
    const cv = st.canvas, dpr = Math.min(2, window.devicePixelRatio || 1), PC = window.PuffContour;
    const cw = Math.round(st.boxW * 1.6 * dpr), ch = Math.round(st.boxH * 1.1 * dpr);
    if (!cw || !ch) return;
    if (cv.width !== cw || cv.height !== ch) { cv.width = cw; cv.height = ch; }
    const ctx = cv.getContext('2d'); ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cw, ch);
    const s = dpr * st.boxW / PC.FW; ctx.setTransform(s, 0, 0, s, -PC.AX * s, -PC.AY * s);
    const col = colors(st.auraId), t = st.t;
    if (st.rings) { // radiation rings: hard comic rings expanding from the chest
      ctx.save(); ctx.lineCap = 'round';
      for (let i = 0; i < 3; i++) {
        const u = ((t / 2.6) + i / 3) % 1, r = 260 + u * 1100;
        ctx.globalAlpha = (1 - u) * 0.85 * st.alpha; ctx.strokeStyle = i % 2 ? '#ffffff' : col.field; ctx.lineWidth = 26 * (1 - u) + 4;
        ctx.beginPath(); ctx.ellipse(540, 1290, r, r * 0.92, 0, 0, Math.PI * 2); ctx.stroke();
      }
      ctx.restore();
    }
    const C = st.contour; if (!C || st.alpha <= 0.01) return;
    const k = Math.max(0, easeOutBack(Math.min(1, st.grow)));
    ctx.globalAlpha = st.alpha;
    const G = window.PuffGrammar, fn = G[st.edge] || G.scallops;
    fn(ctx, C, col, t, k);
    G.particles(ctx, C, col, st.edge, t, Math.min(1, st.grow));
    ctx.globalAlpha = 1;
  }
  window.PuffEdge = { colors, render };
})();


/* ---- puff-video.js ---- */
/* PUFF cut-out video player: WebGL rebuilds the cut-out from an alpha-packed H.264 (picture left half, mask right half).
   Works on iPhone Safari with plain H.264. Vanilla JS. */
(function () {
  if (window.PuffVideo) return;
  const VS = 'attribute vec2 p;varying vec2 uv;void main(){uv=vec2(p.x*.5+.5,.5-p.y*.5);gl_Position=vec4(p,0.,1.);}';
  const FS = 'precision mediump float;varying vec2 uv;uniform sampler2D t;void main(){vec3 c=texture2D(t,vec2(uv.x*.5,uv.y)).rgb;float a=texture2D(t,vec2(.5+uv.x*.5,uv.y)).r;a=smoothstep(.02,.98,a);gl_FragColor=vec4(c*a,a);}';
  function mkVideo(src) {
    const v = document.createElement('video');
    v.src = src; v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); v.preload = 'auto'; v.crossOrigin = 'anonymous';
    return v;
  }
  const seek = (v, time) => new Promise(res => { if (Math.abs(v.currentTime - time) < 0.001 && v.readyState >= 2) return res(); const on = () => { v.removeEventListener('seeked', on); res(); }; v.addEventListener('seeked', on); v.currentTime = time; });
  const canPlay = v => new Promise(res => { if (v.readyState >= 2) return res(); v.addEventListener('loadeddata', () => res(), { once: true }); v.load(); });

  class PuffVideo {
    constructor(canvas, o) {
      this.c = canvas; this.o = Object.assign({ frames: 264, fps: 30 }, o);
      this.vf = mkVideo(o.srcF); this.vr = mkVideo(o.srcR); this.active = this.vf; this.stop = 0; this.busy = null;
      const gl = this.gl = canvas.getContext('webgl', { premultipliedAlpha: true, alpha: true, antialias: false, preserveDrawingBuffer: true });
      if (!gl) return;
      const sh = (type, src) => { const s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return s; };
      const pr = gl.createProgram(); gl.attachShader(pr, sh(gl.VERTEX_SHADER, VS)); gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, FS)); gl.linkProgram(pr); gl.useProgram(pr);
      const b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      const loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      const tx = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, tx);
      [gl.TEXTURE_WRAP_S, gl.TEXTURE_WRAP_T].forEach(p => gl.texParameteri(gl.TEXTURE_2D, p, gl.CLAMP_TO_EDGE));
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.clearColor(0, 0, 0, 0);
      this.ready0 = Promise.all([canPlay(this.vf), canPlay(this.vr)]);
      this.ready = this.ready0.then(() => this.show(this.stop));
    }
    t(frame) { return (frame + 0.5) / this.o.fps; }
    rev(frame) { return this.o.frames - 1 - frame; }
    draw() {
      const gl = this.gl, v = this.active; if (!gl || v.readyState < 2) return;
      const w = this.c.clientWidth * Math.min(2, devicePixelRatio || 1), h = this.c.clientHeight * Math.min(2, devicePixelRatio || 1);
      if (w && (this.c.width !== Math.round(w) || this.c.height !== Math.round(h))) { this.c.width = Math.round(w); this.c.height = Math.round(h); }
      gl.viewport(0, 0, this.c.width, this.c.height); gl.clear(gl.COLOR_BUFFER_BIT);
      try { gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, v); gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4); } catch (e) { }
    }
    async show(i) { await this.ready0; this.stop = i; this.active = this.vf; await seek(this.vf, this.t(this.o.stops[i][0])); this.draw(); }
    // play from the current stop to stop j in direction dir (+1 forward clip, -1 reversed clip). Resolves at the stop.
    goTo(j, dir, rate) {
      const run = async () => {
        const i = this.stop, S = this.o.stops; if (j === i) return;
        await this.ready;
        const fwd = dir > 0, v = fwd ? this.vf : this.vr;
        const from = fwd ? S[i][1] : this.rev(S[i][0]), to = fwd ? S[j][0] : this.rev(S[j][1]);
        await seek(v, this.t(from)); this.active = v; this.draw();
        v.playbackRate = rate || 1;
        await new Promise(res => {
          const end = this.t(to) - 0.5 / this.o.fps, timer = setTimeout(done, ((to - from) / this.o.fps / (rate || 1)) * 1000 + 1500);
          let fin = false;
          function done() { if (fin) return; fin = true; clearTimeout(timer); v.pause(); res(); }
          const tick = () => { if (fin) return; this.draw(); if (v.currentTime >= end || v.ended) return done(); v.requestVideoFrameCallback ? v.requestVideoFrameCallback(tick) : requestAnimationFrame(tick); };
          v.play().then(tick).catch(done);
        });
        await seek(v, this.t(to)); this.draw();
        // hand back to the forward clip at the same frame so the next move can start from either
        await seek(this.vf, this.t(fwd ? to : this.rev(to))); this.active = this.vf; this.draw();
        this.stop = j;
      };
      this.busy = (this.busy || Promise.resolve()).then(run, run);
      return this.busy;
    }
    destroy() { [this.vf, this.vr].forEach(v => { v.pause(); v.removeAttribute('src'); v.load(); }); }
  }
  window.PuffVideo = PuffVideo;
})();


/* ---- puff-model.js ---- */
/* PUFF model stage — <puff-model> custom element. Vanilla JS (Shopify-ready). Needs puff-sky.js, puff-contour.js,
   puff-grammar-a.js, puff-grammar-b.js, puff-edge.js, puff-video.js loaded first.
   Attributes: aura, stop, dir (1|-1), mode (photos|video), edge (on|off), edge-mix (0..1), edge-gap, rings (on|off), speed, base */
(function () {
  if (customElements.get('puff-model')) return;
  const SB = ['01_front', '02_chest_wide', '03_side', '04_sleeve', '05_shoulder', '06_back', '07_full-back'];
  const ALIGN = { red: [-6.02, 14.74, 109.81], orange: [-8.91, 15.52, 119.44], yellow: [-6.56, 13.75, 111.61], green: [-8.29, 12.94, 117.38], 'sky-blue': [-2.83, 18.85, 107.97], blue: [-8.58, 15.26, 116.38], purple: [-8.64, 15.6, 116.88] }; // per picture: aura clear of the banner, tee hem above the widget
  const SRC = { 'red:1': 'assets/ef/red-e-crop.png', 'red:2': 'assets/ef/red-a.jpg', 'red:3': 'assets/ef/red-d.jpg', 'red:4': 'assets/ef/red-c.jpg', 'red:5': 'assets/ef/red-b.jpg', 'orange:1': 'assets/ef/orange-a.jpg', 'orange:2': 'assets/ef/orange-b.jpg', 'orange:3': 'assets/ef/orange-c.jpg', 'orange:4': 'assets/ef/orange-d.jpg', 'orange:5': 'assets/ef/orange-e.jpg', 'yellow:1': 'assets/ef/yellow-c.jpg', 'yellow:2': 'assets/ef/yellow-g.jpg', 'yellow:3': 'assets/ef/yellow-e.jpg', 'yellow:4': 'assets/ef/yellow-f.jpg', 'green:1': 'assets/ef/green-b.jpg', 'green:2': 'assets/ef/green-a.jpg', 'green:3': 'assets/ef/green-d.jpg', 'green:4': 'assets/ef/green-c.jpg', 'blue:1': 'assets/ef/blue-a.jpg', 'blue:2': 'assets/ef/blue-b.jpg', 'blue:3': 'assets/ef/blue-c.jpg', 'blue:4': 'assets/ef/blue-d.jpg', 'blue:5': 'assets/ef/blue-e.jpg', 'purple:1': 'assets/ef/purple-a.jpg', 'purple:2': 'assets/ef/purple-e.jpg', 'purple:3': 'assets/ef/purple-d.jpg', 'purple:4': 'assets/ef/purple-c.jpg', 'purple:5': 'assets/ef/purple-b.jpg', 'sky-blue:11': 'assets/ef/sb-b.jpg', 'sky-blue:12': 'assets/final/sb-553.jpg', 'sky-blue:13': 'assets/ef/sb-a.jpg', 'sky-blue:14': 'assets/ef/sb-d.jpg', 'sky-blue:15': 'assets/ef/sb-c.jpg', 'sky-blue:0': 'assets/aura-ai/sky-blue-glow-anim.webp', 'sky-blue:1': 'assets/sky-blue/01_front.webp', 'sky-blue:2': 'assets/sky-blue/02_chest_wide.webp', 'sky-blue:3': 'assets/sky-blue/03_side.webp', 'sky-blue:4': 'assets/sky-blue/04_sleeve.webp', 'sky-blue:5': 'assets/sky-blue/05_shoulder.webp', 'sky-blue:6': 'assets/sky-blue/06_back.webp', 'sky-blue:7': 'assets/sky-blue/07_full-back.webp', 'sky-blue:vposter': 'assets/video/sky-blue-ecom-poster.webp', 'red:0': 'assets/aura-ai/red-glow.webp', 'orange:0': 'assets/aura-ai/orange-glow.webp', 'yellow:0': 'assets/aura-ai/yellow-glow.webp', 'green:0': 'assets/aura-ai/green-glow.webp', 'blue:0': 'assets/aura-ai/blue-glow.webp', 'purple:0': 'assets/aura-ai/purple-glow.webp' };
  const VSTOPS = [[0, 7], [62, 65], [120, 123], [177, 180], [256, 263]];
  const EASE = 'cubic-bezier(.2,.7,.2,1)';
  const mk = (tag, css) => { const e = document.createElement(tag); e.style.cssText = css; return e; };
  const reduce = () => window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  class PuffModel extends HTMLElement {
    static get observedAttributes() { return ['aura', 'stop', 'dir', 'mode', 'edge', 'edge-mix', 'rings', 'speed']; }
    connectedCallback() {
      if (this._init) { this.resume(); return; }
      this._init = true;
      Object.assign(this.style, { display: 'block', position: this.style.position || 'relative', width: this.style.width || '100%', height: this.style.height || '100%' });
      this.base = this.getAttribute('base') || 'assets/';
      this.edgeCv = mk('canvas', 'position:absolute;left:-30%;top:-10%;width:160%;height:110%;pointer-events:none');
      this.box = mk('div', 'position:absolute;inset:0;clip-path:inset(-40% -40% 0 -40%)');
      this.vcv = mk('canvas', 'position:absolute;inset:0;width:100%;height:100%;opacity:0;transition:opacity .25s;pointer-events:none');
      this.append(this.edgeCv, this.box, this.vcv);
      this.imgs = {}; this.cur = this.read(); this.alpha = 0; this.grow0 = performance.now();
      if (this.isVid()) { this.curImg = this.img('sky-blue', 'vposter'); this.enterVideo(this.cur.stop); }
      else this.curImg = this.img(this.cur.aura, this.cur.stop);
      this.show(this.curImg); this.curImg.style.opacity = '1'; this.curImg._live && this.curImg._live.play();
      SB.forEach((_, i) => this.img('sky-blue', i + 1)); this.img('sky-blue', 0);
      this.io = new IntersectionObserver(es => { this.visible = es[es.length - 1].isIntersecting; this.resume(); this.liveSync(); }, { rootMargin: '120px' });
      this.io.observe(this); this.visible = false;
      document.addEventListener('visibilitychange', () => { this.resume(); this.liveSync(); });
      this.resume();
    }
    disconnectedCallback() { cancelAnimationFrame(this.raf); this.raf = 0; this.curImg && this.curImg._live && this.curImg._live.pause(); }
    liveSync() { const l = this.curImg && this.curImg._live; if (!l) return; if (this.visible === false || document.hidden || !this.isConnected) l.pause(); else l.play(); }
    read() { return { aura: this.getAttribute('aura') || 'sky-blue', stop: +(this.getAttribute('stop') || 0), dir: +(this.getAttribute('dir') || 1) || 1, mode: this.getAttribute('mode') || 'photos' }; }
    isVid(c) { c = c || this.cur; return c.mode === 'video' && c.aura === 'sky-blue'; }
    attributeChangedCallback() { if (!this._init || this._q) return; this._q = true; queueMicrotask(() => { this._q = false; this.sync(); }); }
    src(aura, key) { const P = window.PUFF_SRC; if (P && P[aura + ':' + key]) return P[aura + ':' + key]; const p = SRC[aura + ':' + key] || ''; return this.base === 'assets/' ? p : this.base + p.slice(7); }
    img(aura, key) {
      const id = aura + ':' + key; if (this.imgs[id]) return this.imgs[id];
      if (false && aura === 'sky-blue' && +key === 0 && window.PuffLive) { const w = mk('div', 'position:absolute;inset:0;opacity:0;user-select:none;pointer-events:none;'), a = ALIGN[aura], st = new Image(); st.decoding = 'async'; st.alt = ''; st.draggable = false; st.src = this.src(aura, key); st.style.cssText = `position:absolute;left:${a[0]}%;top:${a[1]}%;width:${a[2]}%;height:auto;transition:opacity .4s;`; w.append(st); w._key = id;
        w._live = { play: () => { if (this.visible === false || document.hidden || this.curImg !== w) return; if (w._L === undefined) { w._L = window.PuffLive(this.base + 'video/' + 'sky-blue-aura.mp4'); if (w._L) { w._L.canvas.style.cssText = 'position:absolute;left:-13%;top:0;width:128.4%;height:auto;aspect-ratio:1320/2348;opacity:0;transition:opacity .4s;'; w._L.onfirst = () => { w._L.canvas.style.opacity = '1'; st.style.opacity = '0'; }; w.append(w._L.canvas); } } w._L && w._L.play(); }, pause: () => { w._L && w._L.pause(); } };
        this.imgs[id] = w; return w; }
      const im = new Image(); im.decoding = 'async'; im.draggable = false; im.alt = '';
      let css = 'position:absolute;opacity:0;user-select:none;pointer-events:none;';
      if (aura === 'sky-blue' && key !== 0 && !(+key > 10)) { im.src = this.src(aura, key); css += 'left:0;top:0;width:100%;height:100%;'; im._rect = { x: 0, y: 0, w: 1080, h: 2340 }; }
      else if (key !== 0) { im.src = this.src(aura, key); css += 'left:3%;top:13%;width:94%;height:auto;aspect-ratio:2/3;object-fit:cover;object-position:50% 35%;background:rgba(255,255,255,.35);border-radius:28px;border:1px solid rgba(255,255,255,.8);box-shadow:inset 1.5px 1.5px 1px rgba(255,255,255,.95),0 0 0 10px rgba(255,255,255,.42),0 16px 36px rgba(13,23,52,.22);box-sizing:border-box;' + (/-poster/.test(SRC[aura + ':' + key] || '') ? 'aspect-ratio:4/5;object-fit:cover;object-position:50% 14%;' : '') + ''; im._rect = { x: 32, y: 304, w: 1015, h: 1522 }; }
      else { const a = ALIGN[aura]; im.src = this.src(aura, key); css += `left:${a[0]}%;top:${a[1]}%;width:${a[2]}%;height:auto;`; im._rect = { x: a[0] * 10.8, y: a[1] * 23.4, w: a[2] * 10.8, h: a[2] * 10.8 * (aura === 'sky-blue' ? 926 / 540 : 2840 / 1776) }; }
      im.style.cssText = css; im._key = id; this.imgs[id] = im; return im;
    }
    show(im) { if (!im.isConnected) this.box.appendChild(im); }
    hide(im) { if (im !== this.curImg && im.isConnected) im.remove(); }
    sync() {
      const n = this.read(), p = this.cur; this.cur = n;
      const auraChanged = n.aura !== p.aura;
      if (auraChanged) { this.grow0 = performance.now() + 120; this.lastC = null; }
      else if (n.stop !== p.stop) this.grow0 = performance.now() - 250;
      if (this.isVid(n)) {
        if (!this.isVid(p)) { this.swapTo(this.img('sky-blue', 'vposter'), auraChanged ? 'v' : 'fade', n.dir); this.enterVideo(n.stop); }
        else if (n.stop !== p.stop) this.videoGo(p.stop, n.stop, n.dir);
        return;
      }
      if (this.isVid(p)) this.vcv.style.opacity = '0';
      const im = this.img(n.aura, n.stop);
      if (im !== this.curImg || this.isVid(p)) this.swapTo(im, auraChanged ? 'v' : (n.mode !== p.mode ? 'fade' : 'h'), n.dir);
    }
    swapTo(im, kind, dir) {
      const out = this.curImg; this.curImg = im;
      const sp = 1 / Math.max(0.3, +(this.getAttribute('speed') || 1)), d = (kind === 'v' ? 480 : 440) * sp, rm = reduce();
      if (out && out !== im) {
        out.getAnimations().forEach(a => a.cancel());
        const to = kind === 'h' ? `translateX(${-dir * 7}%)` : kind === 'v' ? `translateY(${-dir * 5}%) scale(.97)` : 'none';
        out.style.opacity = '0'; out.style.zIndex = '1';
        if (!rm) out.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: to }], { duration: d * 0.75, easing: EASE }).onfinish = () => this.hide(out);
        else this.hide(out);
      }
      this.show(im);
      im.getAnimations().forEach(a => a.cancel());
      im.style.zIndex = '2'; im.style.opacity = '1';
      const from = kind === 'h' ? `translateX(${dir * 7}%) scale(1.035)` : kind === 'v' ? `translateY(${dir * 5}%) scale(1.04)` : 'none';
      if (!rm) im.animate([{ opacity: 0, transform: from }, { opacity: 1, transform: 'none' }], { duration: d, delay: kind === 'v' ? 90 * sp : 0, easing: EASE, fill: 'backwards' });
      if (im._live) im._live.play(); if (out && out !== im && out._live) setTimeout(() => { if (this.curImg !== out) out._live.pause(); }, 800);
    }
    enterVideo(stop) {
      if (!window.PuffVideo) return;
      if (!this.video) this.video = new window.PuffVideo(this.vcv, { srcF: this.base + 'video/' + 'sky-blue-ecom-f.mp4', srcR: this.base + 'video/' + 'sky-blue-ecom-r.mp4', stops: VSTOPS });
      this.video.show(Math.min(stop, 4)).then(() => {
        if (!this.isVid()) return;
        this.vcv.style.opacity = '1';
        const im = this.curImg; if (im) { im.style.transition = 'opacity .3s'; im.style.opacity = '0'; setTimeout(() => { im.style.transition = ''; this.hide(im); }, 350); }
        this.curImg = null;
      });
    }
    videoGo(from, to, dir) {
      const wrap = (dir > 0 && to < from) || (dir < 0 && to > from), rate = +(this.getAttribute('speed') || 1);
      if (!wrap) return this.video.goTo(to, dir, rate);
      this.vcv.style.opacity = '0';
      setTimeout(() => this.video.show(to).then(() => { if (this.isVid()) this.vcv.style.opacity = '1'; }), 260);
    }
    resume() { if (!this.raf && this.visible !== false && !document.hidden && this.isConnected) this.raf = requestAnimationFrame(this.loop || (this.loop = t => this.frame(t))); }
    frame(now) {
      this.raf = 0;
      if (!this.isConnected || this.visible === false || document.hidden) return;
      this.raf = requestAnimationFrame(this.loop);
      if (now - (this.last || 0) < 24) return; this.last = now;
      const c = this.cur, on = this.getAttribute('edge') === 'on', rings = this.getAttribute('rings') === 'on';
      const wide = c.aura !== 'sky-blue' || (this.isVid() ? c.stop === 0 : [0, 2, 6].includes(c.stop));
      const mix = this.hasAttribute('edge-mix') ? +this.getAttribute('edge-mix') : 1, target = on && wide && !(this.curImg && this.curImg._live) ? mix : 0;
      this.alpha += (target - this.alpha) * 0.14;
      const src = this.isVid() ? this.img('sky-blue', 'vposter') : this.curImg;
      if (src && src.complete && src.naturalWidth && window.PuffContour) { const C = window.PuffContour.contour(src, src._rect, +(this.getAttribute('edge-gap') || 44), src._key); if (C) this.lastC = C; }
      const rm = reduce(), aura = window.PuffSky.AURAS.find(a => a.id === c.aura) || {};
      if (this.alpha > 0.01 || rings) { this.drawn = true; window.PuffEdge.render({ canvas: this.edgeCv, boxW: this.offsetWidth, boxH: this.offsetHeight, contour: this.lastC, auraId: c.aura, edge: aura.edge, t: rm ? 0 : now / 1000, grow: rm ? 1 : (now - this.grow0) / 720, alpha: this.alpha, rings: rings && !rm }); }
      else if (this.drawn) { this.drawn = false; this.edgeCv.getContext('2d').clearRect(0, 0, this.edgeCv.width, this.edgeCv.height); }
    }
  }
  customElements.define('puff-model', PuffModel);
})();

